import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SurViewReturnsModel } from "@tSurya/Services/ViewReturnListService";
import { SurViewReturnsDetailsModel } from "@tSurya/Services/ViewReturnsDetailsService";
import { ViewReturnDataState } from "@tSurya/Store/Data/SurViewReturnDataState";
import { ViewReturnsDetailsState } from "@tSurya/Store/Data/ViewReturnsDetailsState";
import { Draft } from "immer";

const initialState: ViewReturnsDetailsState = {
    isLoading: false,
    viewdetailsdata: [],
};
const reducer = {
    "Custom/ViewReturnsDetailsService/BeginLoadViewReturnsDetails": (draft: Draft<ViewReturnsDetailsState>) => {
        draft.isLoading = true;
    },
    "Custom/ViewReturnsDetailsService/CompletedLoadViewReturnsDetails": (
        draft: Draft<ViewReturnsDetailsState>,
        action: { result: SurViewReturnsDetailsModel },
    ) => {
        draft.viewdetailsdata = action.result;
        draft.isLoading = false;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
